import { Box, Container, Flex, Text } from '@mantine/core';
import { ArrowLeftIcon } from '@phosphor-icons/react';
import type { FC } from 'react';

interface BackToGigiProps {
  frontendUrl: string;
}

export const BackToGogigi: FC<BackToGigiProps> = ({ frontendUrl }) => {
  return (
    <Box h={42} left={0} pos="fixed" right={0} style={{ zIndex: 201, background: '#F5F5F5' }} top={0}>
      <Container size="lg">
        <Flex align="center" component="a" gap={8} h={42} href={frontendUrl} style={{ textDecoration: 'none' }}>
          <ArrowLeftIcon color="#000000" size={16} />
          <Text c="black" fw={500} size="sm">
            Back to Gogigi.com
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};
